import { useState } from 'react'
import Select from 'react-select'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { FaHistory } from 'react-icons/fa'
import api from '../../../../helpers/apiRequester'
import Modal from '../../../reusable/modal'
import { StatsView } from '../../statsView'
import styles from '../styles.module.scss'

interface SelectOption {
    value: string
    label: string
}

const dataSetOptions: SelectOption[] = [
    { value: 'all', label: 'All Data' },
    { value: 'Horizon', label: 'Horizon Data' },
    { value: 'Woodville', label: 'Woodville Data' },
    { value: 'CX', label: 'CX Data' },
]

export const LegacyStatsButton = () => {
    const [open, setOpen] = useState(false)
    const [activeData, setActiveData] = useState<SelectOption>(dataSetOptions[0])
    const [overviewData, setOverviewData] = useState<any>(null)
    const [loadingFor, setLoadingFor] = useState<string | null>(null)

    const fetchData = async (option: SelectOption) => {
        setLoadingFor(option.value)
        Loading.circle('Loading legacy stats…')
        try {
            const response = await api({
                url: '/system-overview',
                data: { dataGroup: option.value },
            })
            setOverviewData(response.data)
        } catch (error: any) {
            console.error(error)
            if (error?.response?.status === 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay')
            } else {
                Report.failure('Error', 'Failed to load legacy stats.', 'Okay')
            }
        } finally {
            setLoadingFor(null)
            Loading.remove()
        }
    }

    const openModal = () => {
        setOpen(true)
        if (!overviewData) {
            fetchData(activeData)
        }
    }

    const closeModal = () => {
        setOpen(false)
    }

    const onSelectChange = (option: SelectOption | null) => {
        if (!option) return
        setActiveData(option)
        setOverviewData(null)
        fetchData(option)
    }

    return (
        <>
            <button type="button" className={styles.legacyButton} onClick={openModal}>
                <FaHistory /> View Legacy System Overview
            </button>

            <Modal modalState={open} previewModalAction={closeModal}>
                <div className={styles.legacyModalContent}>
                    <h2 className={styles.legacyModalTitle}>Legacy System Overview</h2>
                    <p className={styles.legacyModalSubtitle}>
                        These figures are retained for reference but are no longer the primary dashboard view.
                    </p>

                    <div className={styles.legacySelector}>
                        <label>Funder Data</label>
                        <Select
                            options={dataSetOptions}
                            value={activeData}
                            onChange={onSelectChange}
                            isDisabled={loadingFor !== null}
                            name="legacyDataSet"
                        />
                    </div>

                    {loadingFor ? (
                        <div className={styles.legacyLoading}>Loading…</div>
                    ) : overviewData?.stats ? (
                        <StatsView stats={overviewData.stats} />
                    ) : (
                        <div className={styles.legacyLoading}>No data</div>
                    )}
                </div>
            </Modal>
        </>
    )
}
